const COMPANY_PARTITA_IVA = '02993340344';
const ELIGIBLE_STATUSES = new Set([
  'sent',
  'accepted_by_transport',
  'sdi_received',
  'delivered',
  'notifica_mancata_consegna',
  'decorrenza_termini',
  'esito_cedente_accettato',
  'completed',
  'imported',
]);
const EXCLUDED_TIPO_DOCUMENTO = new Set([
  // Keep in sync with the invoice list's FatturaPA classifications.
  'TD04', 'TD08',
  'TD16', 'TD17', 'TD18', 'TD19', 'TD20', 'TD21', 'TD22', 'TD23', 'TD28',
]);

export function tipoDocumentoCode(invoice) {
  return invoice?.tipoDocumento
    || invoice?.metadata?.datiGenerali?.tipoDocumento
    || null;
}

export function isAnticipoFatturaEligible(company, invoice) {
  const partitaIva = String(company?.partitaIva || '').replace(/\D/g, '');
  return partitaIva === COMPANY_PARTITA_IVA
    && invoice?.direction === 'outbound'
    && ELIGIBLE_STATUSES.has(invoice?.status)
    && !EXCLUDED_TIPO_DOCUMENTO.has(tipoDocumentoCode(invoice));
}
